module.exports = __webpack_public_path__ + "me.m01.d06.meVE.Apolytikion1.text.ccf6e6db.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/graphics/me.m01.d06.meVE.Apolytikion1.text.png
// module id = PKPt
// module chunks = 0